import { API_ENDPOINTS } from '../constants/apiEndpoints';
import apiClient from './apiClient';

/**
 * @param {{username: string, password: string}} credentials
 * @returns {Promise<{token: string, tokenType: string, user: object}>}
 */
const login = async (credentials) => {
  const response = await apiClient.post(API_ENDPOINTS.auth.login, credentials);
  return response.data;
};

/**
 * @param {{username: string, password: string, firstName?: string, middleName?: string, lastName?: string, email?: string, mobile?: string, employeeId?: string, designation?: string, department?: string, managerUserId?: number, joiningDate?: string}} payload
 */
const register = async (payload) => {
  const response = await apiClient.post(API_ENDPOINTS.auth.register, payload);
  return response.data;
};

const logout = async () => {
  const response = await apiClient.post(API_ENDPOINTS.auth.logout);
  return response.data;
};

export const authService = { login, register, logout };
